import React, { useRef, useEffect, useState } from "react";

import { Button } from "../ui/button";
import { lerPreferencia, gravarPreferencia } from "../../services/preferencias";

const LS_NAME = "audioMessageRate";
const VELOCIDADES = [0.5, 1, 1.5, 2];

export default function Audio({ url }) {
	const audioRef = useRef(null);
	const [audioRate, setAudioRate] = useState(
		parseFloat(lerPreferencia(LS_NAME, "1"))
	);
	const [showButtonRate, setShowButtonRate] = useState(false);

	useEffect(() => {
		audioRef.current.playbackRate = audioRate;
		gravarPreferencia(LS_NAME, audioRate);
	}, [audioRate]);

	useEffect(() => {
		const player = audioRef.current;
		player.onplaying = () => setShowButtonRate(true);
		player.onpause = () => setShowButtonRate(false);
		player.onended = () => setShowButtonRate(false);
	}, []);

	const alternarVelocidade = () => {
		const atual = VELOCIDADES.indexOf(audioRate);
		setAudioRate(VELOCIDADES[(atual + 1) % VELOCIDADES.length] || 1);
	};

	return (
		<div className="flex items-center gap-1.5">
			<audio ref={audioRef} controls className="max-w-full">
				<source src={url} type="audio/ogg" />
			</audio>
			{showButtonRate && (
				<Button
					variant="ghost"
					size="sm"
					className="h-7 shrink-0 px-2 text-xs tabular-nums"
					onClick={alternarVelocidade}
				>
					{audioRate}x
				</Button>
			)}
		</div>
	);
}
